import React from 'react';
import { connect } from 'react-redux';

import { isRunningContextCypress } from '../utils';

const ExposeStateForCypress = state => {
  if (isRunningContextCypress(window)) {
    if (state !== undefined) {
      window.stateForCypress = state;
    }
  }
  return <></>;
};

export default connect(state => state)(ExposeStateForCypress);
